define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 演示子项对象类型。
     *
     * @exports EnumPresentationItemType
     * 
     * @see PresentationItem#type
     */
    var EnumPresentationItemType = {
        /**
         * 视点定位。
         * @type {Number}
         * @constant
         */
        CAMERA: 1,

        /**
         * 对象显示。
         * @type {Number}
         * @constant
         */
        SHOW: 2,

        /**
         * 对象隐藏。
         * @type {Number}
         * @constant
         */
        HIDE: 3,

        /**
         * 对象跟随。
         * @type {Number}
         * @constant
         */
        FOLLOW: 4
    }
    freezeObject(EnumPresentationItemType)
    /**
    * 反向查找对齐方式的名称。
    * 
    * @param {Number} value 对齐方式的数值。
    * @returns {String} 对齐方式的名称。
    */
    function getName(value) {
        for (var key in EnumPresentationItemType) {
            if (EnumPresentationItemType.hasOwnProperty(key) && EnumPresentationItemType[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        CAMERA: 1,
        SHOW: 2,
        HIDE: 3,
        FOLLOW: 4,
        getName: getName
    }
})